import React from "react";
import { formatCurrency, getPerformanceColor } from "../utils/formatters";

/**
 * ColoredCurrency - Displays a currency value with color coding
 * - var(--color-positive) for positive values (theme-aware)
 * - var(--color-negative) for negative values (theme-aware)
 * - var(--stat-label-color) for zero (theme-aware)
 */
const ColoredCurrency = ({ value, className = "" }) => {
  const color = getPerformanceColor(value);

  return (
    <span style={{ color }} className={className}>
      {`${value > 0 ? "+" : ""}${formatCurrency(value)}`}
    </span>
  );
};

export default ColoredCurrency;
